import React from 'react'
import PropTypes from 'prop-types'
import {
  Overlay,
  Text,
  Buttons,
  OverlayButton,
} from './ConfirmationOverlay.style'

const ConfirmationOverlay = ({
  message,
  cancelLabel,
  confirmLabel,
  onCancel,
  onConfirm,
  dataTestId,
  cancelDataTestId,
  confirmDataTestId,
}) => (
  <Overlay data-testid={dataTestId || 'confirmation-overlay'}>
    <Text>{message}</Text>
    <Buttons>
      <OverlayButton
        type="button"
        data-test-id={cancelDataTestId}
        onClick={onCancel}
      >
        {cancelLabel}
      </OverlayButton>
      <OverlayButton
        type="button"
        data-test-id={confirmDataTestId}
        onClick={onConfirm}
      >
        {confirmLabel}
      </OverlayButton>
    </Buttons>
  </Overlay>
)

ConfirmationOverlay.defaultProps = {
  dataTestId: 'confirmation-overlay',
  cancelDataTestId: undefined,
  confirmDataTestId: undefined,
}

ConfirmationOverlay.propTypes = {
  message: PropTypes.string.isRequired,
  cancelLabel: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  dataTestId: PropTypes.string,
  cancelDataTestId: PropTypes.string,
  confirmDataTestId: PropTypes.string,
}

export default ConfirmationOverlay
